import { ContentTypesEnum_class } from "../../common/enums/contentTypes"

export interface FacilityInfoDto {
    id?: string,
    websiteUrl: string,
    description: string,
    fileUpload?: File[],
    content?: FacilityExtraDto[], 
}

export interface FacilityExtraDto {
    id?: string,
    contentTypeId: number,
    content: string,
}

export const facilityInfoInit: FacilityInfoDto = {
    id: '',
    websiteUrl: '',
    description: '',
    fileUpload: [],
    content: []
}

export const facilityExtraInit: FacilityExtraDto = {
    id: '',
    contentTypeId: 0,
    content: ''
}

export const facilityExtraArrayInit: FacilityExtraDto[] = [
    {
        id: '',
        contentTypeId: ContentTypesEnum_class.enum.Guidelines,
        content: ''
    },
    {
        id: '',
        contentTypeId: ContentTypesEnum_class.enum.Contacts,
        content: ''
    },
    {
        id: '',
        contentTypeId: ContentTypesEnum_class.enum.Admission,
        content: ''
    },
    {
        id: '',
        contentTypeId: ContentTypesEnum_class.enum.TermsOfService,
        content: ''
    },
]